export default __webpack_public_path__ + "static/media/signalist.2f374906.jpg";